import FirebaseWrite from "@/services/database/firebaseWrite";
import SpielService from "@/services/data/spielService";
import {BewerbSpiel} from "@/services/data/meisterschaften/bewerbSpiel";

export class BewerbTeam {
    constructor(team, id, type, isTeamForSpiel) {
        this.id = id;
        this.settings = {
            name: team?.settings.name ?? null,
            vereinsName: team?.settings.vereinsName ?? null,
            landesverband: team?.settings.landesverband ?? null,
            ak: team?.settings.ak ?? null,
            player1: team?.settings.player1 ?? this.getEmptyPlayer(''),
            player2: team?.settings.player2 ? team?.settings.player2 : type === 'doppel' ? this.getEmptyPlayer('') : null,
            type: type
        }
        if ( !isTeamForSpiel ) {
            this.results = {
                volle: team?.results.volle ?? 0,
                abraeumen: team?.results.abraeumen ?? 0,
                gesamt: team?.results.gesamt ?? null,
                fehlwuerfe: team?.results.fehlwuerfe ?? 0,
                position: team?.results.position ?? 1000,
                kommentar: team?.results.kommentar ?? '',
                status: team?.results.status ?? '', // 'finished', 'disq', 'dns', 'wo', '' => fertig wenn !== ''
                losEntscheid: team?.results.losEntscheid ?? false,
                positionLos: team?.results.positionLos ?? null,
            }
        }
    }

    getEmptyPlayer(passNumber) {
        return {
            passNumber: passNumber,
            nachname: '',
            vorname: '',
            landesverband: '',
            verein: '',
            ak: '',
            id: '',
            noPass: false,
        }
    }

    clearPlayerExceptPassnumber(player) {
        this.settings[player].nachname = ''
        this.settings[player].vorname = ''
        this.settings[player].landesverband = ''
        this.settings[player].verein = ''
        this.settings[player].ak = ''
    }

    setPlayer(player, person, passNumber, lv, verein, bewerbId) {
        this.settings[player] = {
            passNumber: passNumber,
            nachname: person.nachname,
            vorname: person.vorname,
            landesverband: lv,
            verein: verein,
            ak: SpielService.getAltersklasse(person.dates.akHJ, person.dates.akJahr,
                                           bewerbId, 'classic'),
            id: person.id
        }
    }

    setResultGesamt(){
        this.results.gesamt = (this.results.volle ? parseInt(this.results.volle) : 0) +
                              (this.results.abraeumen ? parseInt(this.results.abraeumen) : 0 )
    }

    settingsComplete() {
        const player1complete = this.settings.player1.nachname && this.settings.player1.vorname &&
                        this.settings.player1.passNumber && this.settings.player1.landesverband && this.settings.player1.verein
        if (this.settings.type === 'einzel') {
            if ( !player1complete && !this.settings.player1.noPass ) return 'Bitte gib eine Passnummer ein und klicke auf Person suchen! Falls die Person' +
                'nicht gefunden wird, gib bitte die Daten manuell ein.'
            return ''
        }
        const player2complete = this.settings.player2.nachname && this.settings.player2.vorname &&
                        this.settings.player2.passNumber && this.settings.player2.landesverband && this.settings.player2.verein
        if ( (!player1complete && !this.settings.player1.noPass) ||
             (!player2complete && !this.settings.player2.noPass )) return 'Bitte gib für beide Spieler eine Passnummer ein und klicke ' +
            'auf Personen suchen! Falls die Personen nicht gefunden werden, gib bitte die Daten manuell ein.'
        return ''
    }

    async updateTeamInRunde(bewerbId, rundeId){
        const dataObject = JSON.parse(JSON.stringify(this))
        return await FirebaseWrite.updateTeamInRunde(bewerbId, dataObject, rundeId)
    }

    async updateTeamResultsInRunde(bewerbId, rundeId){
        const dataObject = JSON.parse(JSON.stringify(this))
        dataObject.results.volle = dataObject.results.volle ? parseInt(dataObject.results.volle):0
        dataObject.results.abraeumen = dataObject.results.abraeumen ? parseInt(dataObject.results.abraeumen):0
        dataObject.results.gesamt = dataObject.results.gesamt ? parseInt(dataObject.results.gesamt) : 0
        dataObject.results.fehlwuerfe = dataObject.results.fehlwuerfe ? parseInt(dataObject.results.fehlwuerfe) : 0
        dataObject.results.positionLos = dataObject.results.positionLos ? parseInt(dataObject.results.positionLos) : null
        return await FirebaseWrite.updateTeamResultsInRunde(bewerbId, dataObject, rundeId)
    }

    async updateTeamInKoRunde(bewerbId, runde, currentSpiel, isFreilos){
        const dataObject = JSON.parse(JSON.stringify(this))
        delete dataObject.id
        const teamKey = currentSpiel.teamKey
        const spiel = new BewerbSpiel(currentSpiel.spielData, null,
                            Object.keys(currentSpiel.spielData.saetze).length)
        const path = 'runden.' + runde.id + '.spiele.' + spiel.id + '.'
        const spielUpdate = spiel.getSpielUpdateAfterTeamUpdate(dataObject, teamKey,
                                                                      isFreilos, path)
        const reply = await FirebaseWrite.update('meisterschaftenBewerbe', bewerbId,
                                                spielUpdate )
        reply.spiel = spiel
        return reply
    }
}